/* Two stable garment views. Variant/design changes replace images, never slides. */
(function () {
  'use strict';
  function file(image) { return String(image.src || '').split('?')[0].split('/').pop().toLowerCase(); }
  function isFront(image) { return /front|run_it_monogram_reflective_t-shirt|runit_reflective_tshirt|runitcargos2/.test(file(image)); }
  function images(product) {
    var media = product.media && product.media.filter(function (m) { return m.media_type === 'image'; });
    return media && media.length ? media.map(function (m) { return { id: m.id, src: m.src || m.preview_image.src, alt: m.alt || '' }; }) :
      (product.images || []).map(function (m, i) { return typeof m === 'string' ? { src: m, id: i } : m; });
  }
  function resolve(product, opts) {
    var photos = images(product), front = photos.find(isFront);
    var back = photos.find(function (m) { return /runitcargos3/.test(file(m)); }) || photos.find(function (m) { return !isFront(m) && /back/.test(file(m)); }) || photos.find(function (m) { return !isFront(m); });
    var variant = (product.variants || []).find(function (v) { return (v.options || []).every(function (o, i) { return !opts || !opts[i] || opts[i] === o; }); });
    var featured = variant && variant.featured_image;
    if (!featured && opts) {
      var finishIndex = (product.options || []).findIndex(function (o) { return /print|finish/i.test(typeof o === 'string' ? o : o.name); });
      var finish = String(opts[finishIndex] || '').toLowerCase();
      var backs = photos.filter(function (m) { return !isFront(m) && !/\.jpe?g$|runit-pdp-/.test(file(m)); });
      if (finish) {
        var non = backs.find(function (m) { return /non[-_]?reflect/.test(file(m)); });
        var ref = backs.find(function (m) { return /reflect|refelct|relfect|_refl/.test(file(m)) && !/non[-_]?reflect/.test(file(m)); });
        if (/non/.test(finish)) back = non || backs.find(function (m) { return m !== ref; }) || back;
        else if (/reflect/.test(finish)) back = ref || back;
      }
    }
    if (featured) {
      var photo = photos.find(function (m) { return String(m.id) === String(featured.id) || String(m.src).split('?')[0] === String(featured.src).split('?')[0]; }) || featured;
      if (isFront(photo)) front = photo; else back = photo;
    }
    var overridesNode = document.querySelector && document.querySelector('[data-runit-view-overrides]');
    var overrides = overridesNode && JSON.parse(overridesNode.textContent)[product.handle];
    if (overrides && back) {
      var oi = (product.options || []).findIndex(function (o) { return /print|finish/i.test(typeof o === 'string' ? o : o.name); });
      var value = String(opts && opts[oi] || variant && variant.options[oi] || '').toLowerCase();
      var key = /reflect/.test(value) && !/non/.test(value) ? 'reflective' : 'nonreflective';
      if (overrides[key]) back = { id: back.id, src: overrides[key] };
    }
    return { back: back, front: front };
  }
  function setImage(img, photo, view, title) {
    if (!photo) return;
    var src = photo.src;
    if (img.getAttribute('data-runit-view-src') !== src) {
      img.removeAttribute('srcset'); img.src = src;
      img.setAttribute('data-runit-view-src', src);
    }
    img.alt = (title || 'Garment') + ' · ' + (view === 'front' ? 'Front View' : 'Back View');
  }
  function apply(gallery, product, opts) {
    if (!product) {
      var node = gallery.querySelector('[data-runit-view-product]');
      if (!node) return;
      product = JSON.parse(node.textContent);
    }
    var views = resolve(product, opts);
    ['back', 'front'].forEach(function (view) {
      var photo = views[view], slide = gallery.querySelector('[data-runit-view="' + view + '"]');
      if (!photo || !slide) return;
      slide.querySelectorAll('img').forEach(function (img) { setImage(img, photo, view, product.title); });
      var thumb = gallery.querySelector('[data-runit-view-thumb="' + view + '"]');
      if (thumb) {
        thumb.querySelectorAll('img').forEach(function (img) { setImage(img, photo, view, product.title); });
        thumb.querySelector('button').setAttribute('aria-label', view === 'front' ? 'Front View' : 'Back View');
      }
      var stableId = slide.dataset.mediaId.split('-').pop();
      slide.querySelectorAll('modal-opener, .product__media-toggle').forEach(function (el) { el.setAttribute('data-media-id', stableId); });
      var modal = document.getElementById('ProductModal-' + gallery.dataset.section);
      if (modal) modal.querySelectorAll('[data-media-id="' + stableId + '"]').forEach(function (el) {
        if (el.tagName === 'IMG') setImage(el, photo, view, product.title);
        else el.querySelectorAll('img').forEach(function (img) { setImage(img, photo, view, product.title); });
      });
    });
    var modal = document.getElementById('ProductModal-' + gallery.dataset.section);
    var ids = Array.from(gallery.querySelectorAll('[data-runit-view]')).map(function (slide) { return slide.dataset.mediaId.split('-').pop(); });
    if (modal) modal.querySelectorAll('[data-media-id]').forEach(function (el) { el.hidden = ids.indexOf(el.dataset.mediaId) === -1; });
  }
  window.rlProductViews = { resolve: resolve, apply: apply, setImage: setImage };
  function init() {
    document.querySelectorAll('[data-runit-product-views]').forEach(function (gallery) {
      var scope = gallery.closest('section'), picker = scope && scope.querySelector('variant-selects, variant-radios');
      function sync() {
        var opts = picker && Array.from(picker.querySelectorAll('.product-form__input')).map(function (group) {
          return (group.querySelector('input:checked') || group.querySelector('select') || {}).value;
        });
        apply(gallery, null, opts);
      }
      sync();
      if (picker) picker.addEventListener('change', sync);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
